/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import * as Sentry from '@sentry/browser';

import ResetPasswordMainDumb from './ResetPasswordMainDumb';
import { validatePasswordLink } from 'src/shared/app/authentication/action/base/authenticationActions';
import {
  getAuthenticationResetToken,
  getAuthenticationUid,
  isPasswordLinkInvalid,
} from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { isErrorReportingEnabled } from 'src/shared/app/base/selector/appEnvSelectors';
import withMount from 'src/shared/app/base/component/hoc/withMount';
import { isHTTP4xxError } from 'src/shared/core/util/httpUtils';

import type { State } from 'src/shared/core/type/reduxTypes';

const mapStateToProps = (state: State): Object => ({
  isPasswordLinkInvalid: isPasswordLinkInvalid(state),
  // Used in `mergeProps` ony
  resetToken: getAuthenticationResetToken(state),
  uid: getAuthenticationUid(state),
  isErrorReportingEnabled: isErrorReportingEnabled(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { isErrorReportingEnabled, resetToken, uid } = stateProps;

  return {
    ...stateProps,
    handleMount() {
      if (uid && resetToken) {
        dispatch(validatePasswordLink(resetToken, uid)).catch((e) => {
          if (isErrorReportingEnabled && !isHTTP4xxError(e)) {
            Sentry.captureException(e);
          } else {
            // TODO: handle error in UI
          }
        });
      }
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(ResetPasswordMainDumb);
